import React from 'react';
import { compose, withStateHandlers } from 'recompose';
import { InputButtonWithIcon as ButtonWithIcon } from '../../../components/buttons/button-with-icon';
import { AccountPage } from '../../../templates/account';
import { withBarrier } from '../../barrier';
import { DeleteAccountModal } from '../components/modals';

const Component = ({ show, handleModal }) => {
  const {
    ACCOUNT: {
      MAIN: {
        pages: {
          deleteAccount: {
            title,
            identifier,
            subheading,
            inPageMessage,
            message,
            heading,
            body,
            legalFooter,
            pageHeader,
            buttons: { confirm }
          }
        }
      }
    }
  } = window.CONFIG;

  return (
    <AccountPage
      title={title}
      subheading={subheading}
      category={identifier}
      inPageMessage={inPageMessage}
      message={message}
      heading={heading}
      body={body}
      legalFooter={legalFooter}
      modal={<DeleteAccountModal show={show} onClose={handleModal} />}
      onSubmit={handleModal}
      pageHeader={pageHeader}
    >
      <ButtonWithIcon buttonType='submit'>{confirm}</ButtonWithIcon>
    </AccountPage>
  );
};

export const DeleteAccount = compose(
  withBarrier,
  withStateHandlers(({ show = false }) => ({ show }), {
    handleModal:
      ({ show }) =>
      () => ({ show: !show })
  })
)(Component);
